import { $t } from "../i18n";

export const format_time_from_seconds = (time_s, show_seconds, show_pretty) => {
    if (!time_s && !show_pretty) return "";
    let h, m, rem, s;
    if (show_seconds == null) {
        show_seconds = true;
    }
    if (show_pretty == null) {
        show_pretty = false;
    }
    rem = Math.abs(time_s % 3600);
    h = Math.floor(time_s / 3600);
    m = Math.abs(Math.floor(rem / 60));
    if (show_pretty) {
        if (h > 0 && m > 0) {
            return "{0}h {1}min".format(h, m);
        } else if (h > 0) {
            return "{0}h".format(h);
        } else if (m > 0) {
            return "{0}min".format(m);
        } else {
            return "0";
        }
    } else if (show_seconds) {
        s = rem % 60;
        return "{0}:{1}:{2}".format(h, (m < 10 ? "0" : "") + m, (s < 10 ? "0" : "") + s);
    } else {
        return "{0}:{1}".format(h, (m < 10 ? "0" : "") + m);
    }
};

export const format_nth_day_text = day => {
    let value = null;
    let text = null;
    if (typeof day === "object") {
        value = day.value;
        text = day.text;
    } else {
        value = day;
        text = String(day)
    }

    if (value === -1) {
        return $t("Last day of the month");
    } else if (value === 0) {
        return $t("Creation date");
    } else {
        return $t("Day {0} of next month").format(text);
    }
};

export const get_currency_from_code = code => {
    //TODO :: maybe there's a better way for this
    if (code === "no") {
        return "NOK";
    } else if (code === "se") {
        return "SEK";
    } else if (code === "ru") {
        return "RUB";
    } else if (code === "us") {
        return "USD";
    } else if (code === "dk") {
        return "DKK";
    } else if (code === "gb") {
        return "GBP";
    } else if (code === "ca") {
        return "CAD";
    } else if (code === "au") {
        return "AUD";
    }
    return "EUR";
};

export const getCurrencySymbolFromCurrency = code => {
    const currencySymbols = {
        EUR: "€",
        USD: "$",
        GBP: "£",
        PLN: "zł",
    }
    return currencySymbols[code] ? currencySymbols[code] : code
};

export const formatAddress = (item, locale_code="") => {
    const a = [];
    if (item.address_street) a.push(item.address_street);

    if (item.address_zip && item.address_city) {
        a.push(item.address_zip + " " + item.address_city);
    } else {
        if (item.address_zip) a.push(item.address_zip);
        if (item.address_city) a.push(item.address_city);
    }

    if (item.address_state) a.push(item.address_state);
    if (item.address_country_code) {
        const country = get_country_from_code(item.address_country_code.toUpperCase())

        a.push($t(country, locale_code));
    } 
    return a.join(", ");
};

export const get_country_from_code = code => {
    const isoCountries = {
        "GB": ("United Kingdom"),
        "EE": ("Estonia"),
        "DK": ("Denmark"),
        "LV": ("Latvia"),
        "LT": ("Lithuania"),
        "FI": ("Finland"),
        "SE": ("Sweden"),
        "NO": ("Norway"),
        "PL": ("Poland"),
        "RU": ("Russian Federation"),
        "AF": ("Afghanistan"),
        "AX": ("Aland Islands"),
        "AL": ("Albania"),
        "DZ": ("Algeria"),
        "AS": ("American Samoa"),
        "AD": ("Andorra"),
        "AO": ("Angola"),
        "AI": ("Anguilla"),
        "AQ": ("Antarctica"),
        "AG": ("Antigua And Barbuda"),
        "AR": ("Argentina"),
        "AM": ("Armenia"),
        "AW": ("Aruba"),
        "AU": ("Australia"),
        "AT": ("Austria"),
        "AZ": ("Azerbaijan"),
        "BS": ("Bahamas"),
        "BH": ("Bahrain"),
        "BD": ("Bangladesh"),
        "BB": ("Barbados"),
        "BY": ("Belarus"),
        "BE": ("Belgium"),
        "BZ": ("Belize"),
        "BJ": ("Benin"),
        "BM": ("Bermuda"),
        "BT": ("Bhutan"),
        "BO": ("Bolivia"),
        "BA": ("Bosnia And Herzegovina"),
        "BW": ("Botswana"),
        "BV": ("Bouvet Island"),
        "BR": ("Brazil"),
        "IO": ("British Indian Ocean Territory"),
        "BN": ("Brunei Darussalam"),
        "BG": ("Bulgaria"),
        "BF": ("Burkina Faso"),
        "BI": ("Burundi"),
        "KH": ("Cambodia"),
        "CM": ("Cameroon"),
        "CA": ("Canada"),
        "CV": ("Cape Verde"),
        "KY": ("Cayman Islands"),
        "CF": ("Central African Republic"),
        "TD": ("Chad"),
        "CL": ("Chile"),
        "CN": ("China"),
        "CX": ("Christmas Island"),
        "CC": ("Cocos (Keeling) Islands"),
        "CO": ("Colombia"),
        "KM": ("Comoros"),
        "CG": ("Congo"),
        "CD": ("Congo, Democratic Republic"),
        "CK": ("Cook Islands"),
        "CR": ("Costa Rica"),
        "CI": ("Cote D'Ivoire"),
        "HR": ("Croatia"),
        "CU": ("Cuba"),
        "CY": ("Cyprus"),
        "CZ": ("Czech Republic"),
        "DJ": ("Djibouti"),
        "DM": ("Dominica"),
        "DO": ("Dominican Republic"),
        "EC": ("Ecuador"),
        "EG": ("Egypt"),
        "SV": ("El Salvador"),
        "GQ": ("Equatorial Guinea"),
        "ER": ("Eritrea"),
        "ET": ("Ethiopia"),
        "FK": ("Falkland Islands (Malvinas)"),
        "FO": ("Faroe Islands"),
        "FJ": ("Fiji"),
        "FR": ("France"),
        "GF": ("French Guiana"),
        "PF": ("French Polynesia"),
        "TF": ("French Southern Territories"),
        "GA": ("Gabon"),
        "GM": ("Gambia"),
        "GE": ("Georgia"),
        "DE": ("Germany"),
        "GH": ("Ghana"),
        "GI": ("Gibraltar"),
        "GR": ("Greece"),
        "GL": ("Greenland"),
        "GD": ("Grenada"),
        "GP": ("Guadeloupe"),
        "GU": ("Guam"),
        "GT": ("Guatemala"),
        "GG": ("Guernsey"),
        "GN": ("Guinea"),
        "GW": ("Guinea-Bissau"),
        "GY": ("Guyana"),
        "HT": ("Haiti"),
        "HM": ("Heard Island & Mcdonald Islands"),
        "VA": ("Holy See (Vatican City State)"),
        "HN": ("Honduras"),
        "HK": ("Hong Kong"),
        "HU": ("Hungary"),
        "IS": ("Iceland"),
        "IN": ("India"),
        "ID": ("Indonesia"),
        "IR": ("Iran, Islamic Republic Of"),
        "IQ": ("Iraq"),
        "IE": ("Ireland"),
        "IM": ("Isle Of Man"),
        "IL": ("Israel"),
        "IT": ("Italy"),
        "JM": ("Jamaica"),
        "JP": ("Japan"),
        "JE": ("Jersey"),
        "JO": ("Jordan"),
        "KZ": ("Kazakhstan"),
        "KE": ("Kenya"),
        "KI": ("Kiribati"),
        "KR": ("Korea"),
        "KW": ("Kuwait"),
        "KG": ("Kyrgyzstan"),
        "LA": ("Lao People's Democratic Republic"),
        "LB": ("Lebanon"),
        "LS": ("Lesotho"),
        "LR": ("Liberia"),
        "LY": ("Libyan Arab Jamahiriya"),
        "LI": ("Liechtenstein"),
        "LU": ("Luxembourg"),
        "MO": ("Macao"),
        "MK": ("Macedonia"),
        "MG": ("Madagascar"),
        "MW": ("Malawi"),
        "MY": ("Malaysia"),
        "MV": ("Maldives"),
        "ML": ("Mali"),
        "MT": ("Malta"),
        "MH": ("Marshall Islands"),
        "MQ": ("Martinique"),
        "MR": ("Mauritania"),
        "MU": ("Mauritius"),
        "YT": ("Mayotte"),
        "MX": ("Mexico"),
        "FM": ("Micronesia, Federated States Of"),
        "MD": ("Moldova"),
        "MC": ("Monaco"),
        "MN": ("Mongolia"),
        "ME": ("Montenegro"),
        "MS": ("Montserrat"),
        "MA": ("Morocco"),
        "MZ": ("Mozambique"),
        "MM": ("Myanmar"),
        "NA": ("Namibia"),
        "NR": ("Nauru"),
        "NP": ("Nepal"),
        "NL": ("Netherlands"),
        "AN": ("Netherlands Antilles"),
        "NC": ("New Caledonia"),
        "NZ": ("New Zealand"),
        "NI": ("Nicaragua"),
        "NE": ("Niger"),
        "NG": ("Nigeria"),
        "NU": ("Niue"),
        "NF": ("Norfolk Island"),
        "MP": ("Northern Mariana Islands"),
        "OM": ("Oman"),
        "PK": ("Pakistan"),
        "PW": ("Palau"),
        "PS": ("Palestinian Territory, Occupied"),
        "PA": ("Panama"),
        "PG": ("Papua New Guinea"),
        "PY": ("Paraguay"),
        "PE": ("Peru"),
        "PH": ("Philippines"),
        "PN": ("Pitcairn"),
        "PT": ("Portugal"),
        "PR": ("Puerto Rico"),
        "QA": ("Qatar"),
        "RE": ("Reunion"),
        "RO": ("Romania"),
        "RW": ("Rwanda"),
        "BL": ("Saint Barthelemy"),
        "SH": ("Saint Helena"),
        "KN": ("Saint Kitts And Nevis"),
        "LC": ("Saint Lucia"),
        "MF": ("Saint Martin"),
        "PM": ("Saint Pierre And Miquelon"),
        "VC": ("Saint Vincent And Grenadines"),
        "WS": ("Samoa"),
        "SM": ("San Marino"),
        "ST": ("Sao Tome And Principe"),
        "SA": ("Saudi Arabia"),
        "SN": ("Senegal"),
        "RS": ("Serbia"),
        "SC": ("Seychelles"),
        "SL": ("Sierra Leone"),
        "SG": ("Singapore"),
        "SK": ("Slovakia"),
        "SI": ("Slovenia"),
        "SB": ("Solomon Islands"),
        "SO": ("Somalia"),
        "ZA": ("South Africa"),
        "GS": ("South Georgia And Sandwich Isl."),
        "ES": ("Spain"),
        "LK": ("Sri Lanka"),
        "SD": ("Sudan"),
        "SR": ("Suriname"),
        "SJ": ("Svalbard And Jan Mayen"),
        "SZ": ("Swaziland"),
        "CH": ("Switzerland"),
        "SY": ("Syrian Arab Republic"),
        "TW": ("Taiwan"),
        "TJ": ("Tajikistan"),
        "TZ": ("Tanzania"),
        "TH": ("Thailand"),
        "TL": ("Timor-Leste"),
        "TG": ("Togo"),
        "TK": ("Tokelau"),
        "TO": ("Tonga"),
        "TT": ("Trinidad And Tobago"),
        "TN": ("Tunisia"),
        "TR": ("Turkey"),
        "TM": ("Turkmenistan"),
        "TC": ("Turks And Caicos Islands"),
        "TV": ("Tuvalu"),
        "UG": ("Uganda"),
        "UA": ("Ukraine"),
        "AE": ("United Arab Emirates"),
        "US": ("United States"),
        "UM": ("United States Outlying Islands"),
        "UY": ("Uruguay"),
        "UZ": ("Uzbekistan"),
        "VU": ("Vanuatu"),
        "VE": ("Venezuela"),
        "VN": ("Viet Nam"),
        "VG": ("Virgin Islands, British"),
        "VI": ("Virgin Islands, U.S."),
        "WF": ("Wallis And Futuna"),
        "EH": ("Western Sahara"),
        "YE": ("Yemen"),
        "ZM": ("Zambia"),
        "ZW": ("Zimbabwe"),
    };

    if (Object.hasOwnProperty.call(isoCountries, code.toUpperCase())) {
        return isoCountries[code.toUpperCase()];
    } else {
        return code;
    }
};
export const get_language_from_code = code => {
    if (!code) {
        return null
    }

    const lang_code = code.substring(0, 2);

    const isoLanguages = {
        en: $t("English"),
        et: $t("Estonian"),
        dk: $t("Danish"),
        lt: $t("Lithuanian"),
        ru: $t("Russian"),
        fi: $t("Finnish"),
        sv: $t("Swedish"),
        nb: $t("Norwegian"),
        lv: $t("Latvian"),
        ar: ("Arabic"),
        az: ("Azerbaijani"),
        be: ("Belorussian"),
        bg: $t("Bulgarian"),
        bs: ("Bosnian"),
        ca: ("Catalan"),
        cs: ("Czech"),
        de: $t("German"),
        es: $t("Spanish"),
        fa: ("Persian"),
        fr: ("French"),
        el: ("Greek"),
        he: ("Hebrew"),
        hr: ("Croatian"),
        hu: ("Hungarian"),
        hy: ("Armenian"),
        it: ("Italian"),
        id: ("Indonesian"),
        ja: ("Japanese"),
        ka: ("Georgian"),
        kk: ("Kazakh"),
        ko: ("Korean"),
        ky: ("Kyrgyz"),
        mk: ("Macedonian"),
        mn: ("Mongolian"),
        nl: ("Dutch"),
        nn: ("Norwegian Nynorsk"),
        pl: $t("Polish"),
        pt: ("Portuguese"),
        ro: ("Romanian"),
        sk: ("Slovak"),
        sl: ("Slovene"),
        sr: ("Serbian"),
        th: ("Thai"),
        tr: ("Turkish"),
        uk: ("Ukrainian"),
        ur: ("Urdu"),
        uz: ("Uzbek"),
        zh: ("Chinese"),
        vi: ("Vietnamese"),
    };
    if (Object.hasOwnProperty.call(isoLanguages, lang_code)) {
        return formatLanguageLabel({name: isoLanguages[lang_code], code: code});
    } else {
        return lang_code;
    }
};

export const formatLanguageLabel = (ui_language) => {
    const appendix = ui_language.code === 'en_GB' ? ' (UK)' : ui_language.code === 'en_US' ? ' (US)' : ''
    return ui_language.name + appendix
}

export const getDescriptionWithoutLinks = (description) => {
    const doc = new DOMParser().parseFromString(description, "text/html");
    return doc.documentElement.textContent.replaceAll(/<a[^>]*>|<\/a>/g, '')
}

export const getDescriptionWithLinks = (description) => {
    return getDescriptionWithoutLinks(description).replaceAll(
        // eslint-disable-next-line no-useless-escape
        /((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~,#?&//=]*))/g,
        (url) => {
            let newUrl = url
            if (url.search(/^http[s]?\:\/\//) === -1) {
                newUrl = "https://" + url
            }

            return `<a href="${newUrl}" target="_blank">${url}</a>`;
        }
    );
}